// hooks/useApi.js
import { useState, useCallback } from 'react';
import CoreHttpHandler from 'http/services/CoreHttpHandler';

const useApi = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const request = useCallback(({
        module,
        method,
        payload,
        onSuccess,
        onError,
        onFinally
    }) => {
        setIsLoading(true);
        setError(null);

        CoreHttpHandler.request(
            module,
            method,
            payload,
            response => {
                setIsLoading(false);
                onSuccess?.(response);
                onFinally?.();
            },
            err => {
                setIsLoading(false);
                const errorMessage = err.response?.data?.message || 'Something went wrong';
                setError(errorMessage);
                onError?.(errorMessage, err);
                onFinally?.();
            }
        );
    }, []);

    return {
        isLoading,
        error,
        request
    };
};

export default useApi;